// Deliberately left without real contact details - decide together with Dash
// what he actually wants public, then fill it in. To add a line, copy the
// commented example below.
export const Contact = () => (
  <>
    <header className="page-header">
      <h1>Get in touch</h1>
      <p className="tagline">Say hi</p>
    </header>
    <ul className="contact-list">
      {/* <li><a href="mailto:you@example.com">Email - you@example.com</a></li> */}
      <li className="empty-note">
        Nothing here yet. Add a link in <code>src/pages/Contact.js</code>.
      </li>
    </ul>
  </>
);
